export const PIPELINE_STATUSES = [
  "CREATED",
  "INFO",
  "IN_PROGRESS",
  "ERROR",
  "SUCCESS",
  "RETRY_REQUESTED",
  "IGNORED",
];

export function pipelineStatusFromQuery(status) {
  return PIPELINE_STATUSES.includes(status) ? status : null;
}

export const pipeline = {
  getStatusColor: function(status) {
    switch (status) {
      case "SUCCESS":
        return "green";
      case "ERROR":
        return "red";
      case "CREATED":
      case "INFO":
        return "blue";
      case "IN_PROGRESS":
        return "orange";
      default:
        return "grey";
    }
  },
  getTypeColor: function(type) {
    switch (type) {
      case "input":
        return "blue";
      case "output":
        return "green";
      case "error":
        return "red";
      default:
        return "grey";
    }
  },
};
